import React, { useState, useEffect, useContext } from "react";
import { Grid, CircularProgress, TableContainer, IconButton, Button, Stack, Divider } from "@mui/material";
import { withStyles } from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import EditIcon from "@mui/icons-material/Edit";

import Paper from "@mui/material/Paper";
import { withSnackbar } from "notistack";
import performRequest from "network/perform-request";
import { punctuationIndexRoute } from "network/api-routes";
import RevaText from "components/common/RevaText";
import { ROUTES } from "constants/routes";
import UserContext from "context/UserContext";
import { Link as RouterLink, useHistory } from "react-router-dom";

const styles = (theme) => ({
  tableContainer: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  createButton: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  sectionTitleContainer: {
    justifyContent: "space-between",
    alignItems: "center",
  },

  sectionTitle: {
    textTransform: "uppercase",
    fontWeight: 500,
    fontSize: 14,
  },
});

/*
 *
 * a component that shows a list of punctuation rules. Retrieves from server and shows them.
 * it also has a search bar to filter the list and a button to create a new one
 */
const PunctuationIndex = (props) => {
  const { user, selectedOrganization } = useContext(UserContext);
  const { classes, enqueueSnackbar } = props;
  const [ready, setReady] = useState(false);
  const [punctuationList, setPunctuationList] = useState([]);
  const history = useHistory();

  //on mount, fetch the list of tournaments
  useEffect(() => {
    performRequest("POST", punctuationIndexRoute, { organization_id: selectedOrganization?.id || null }, true, user)
      .then((response) => {
        if (response.data) {
          setPunctuationList(response.data);
          setReady(true);
        }
      })
      .catch((error) => {
        console.log(error);
        enqueueSnackbar(error.message, { variant: "error" });
        setReady(true);
      });
  }, [enqueueSnackbar, user]);

  if (!ready)
    return (
      <Grid container className={classes.container} justifyContent="center">
        <CircularProgress size={24} />
      </Grid>
    );

  return (
    <Stack>
      <Stack direction="row" className={classes.sectionTitleContainer}>
        <RevaText variant="h4">{`Sistemas de puntuación ${selectedOrganization?.name}`}</RevaText>
        <Button
          component={RouterLink}
          to={`${ROUTES.ADMIN.ORGANIZATIONS}/punctuations/create`}
          className={`cta ${classes.createButton}`}
        >
          Crear nuevo sistema
        </Button>
      </Stack>
      <Divider sx={{ my: 2 }} />
      <TableContainer component={Paper} sx={{ borderRadius: 2 }}>
        <Table>
          <TableHead sx={{ backgroundColor: "grey.900" }}>
            <TableRow>
              <TableCell sx={{ fontWeight: 600 }}>Nombre</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Descripción</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Organización</TableCell>
              <TableCell align="center" sx={{ fontWeight: 600 }}>
                Acciones
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {punctuationList?.map((punctuation) => (
              <TableRow key={punctuation.id} hover sx={{ backgroundColor: "background.paper" }}>
                <TableCell component="th" scope="row">
                  {punctuation.name}
                </TableCell>
                <TableCell component="th" scope="row">
                  {punctuation.description}
                </TableCell>
                <TableCell component="th" scope="row">
                  {punctuation?.organization?.name ?? "Ninguna"}
                </TableCell>
                <TableCell align="center" component="th" scope="row">
                  <IconButton
                    aria-label="edit"
                    size="small"
                    onClick={() => {
                      history.push(`${ROUTES.ADMIN.ORGANIZATIONS}/punctuations/${punctuation.uuid_}/edit`);
                    }}
                    className={classes.editButtonContainer}
                  >
                    <EditIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  );
};

export default withSnackbar(withStyles(styles)(PunctuationIndex));
